import { render, staticRenderFns } from "./VeiculoModal.vue?vue&type=template&id=2e1a6124&scoped=true"
import script from "./VeiculoModal.vue?vue&type=script&lang=js"
export * from "./VeiculoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1a6124",
  null
  
)

export default component.exports